import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { BrokerInformationSection } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface BrokerInformationFormData {
  tpoCompanyNmlsNumber: string;
  processorName: string;
  processorEmail: string;
  loName: string;
  loEmail: string;
  tpoCompanyName: string;
  tpoCompanyPhone: string;
  tpoCompanyFax: string;
  willSnapDocsBeUsed: boolean | null;
  isHybridClosing: boolean | null;
}

@Component({
  selector: 'broker-information',
  templateUrl: './broker-information.component.html',
  styleUrls: ['./broker-information.component.scss'],
  standalone: false
})
export class BrokerInformationComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('brokerInfoForm') brokerInfoForm: NgForm;

  @Input() brokerInformation: BrokerInformationSection | undefined;
  @Input() willSnapDocsBeUsed: boolean | null;
  @Input() isHybridClosing: boolean | null;

  formData: BrokerInformationFormData = {
    tpoCompanyNmlsNumber: '',
    processorName: '',
    processorEmail: '',
    loName: '',
    loEmail: '',
    tpoCompanyName: '',
    tpoCompanyPhone: '',
    tpoCompanyFax: '',
    willSnapDocsBeUsed: null,
    isHybridClosing: null,
  };

  isLoading: boolean = false;

  yesNoOptions: { value: boolean | null; label: string }[] = [
    { value: null, label: 'Select...' },
    { value: true, label: 'Yes' },
    { value: false, label: 'No' }
  ];

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['brokerInformation'] || changes['willSnapDocsBeUsed'] || changes['isHybridClosing']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.brokerInfoForm) {
      this.brokerInfoForm.form.markAllAsTouched();
      return this.brokerInfoForm.form.valid;
    }
    return true;
  }

  getFormData(): BrokerInformationFormData {
    return { ...this.formData };
  }

  private populateFormFromApiData(): void {
    if (this.brokerInformation) {
      this.formData.tpoCompanyNmlsNumber = this.brokerInformation.tpoCompanyNmls || '';
      this.formData.processorName = this.brokerInformation.processorName || '';
      this.formData.processorEmail = this.brokerInformation.processorEmail || '';
      this.formData.loName = this.brokerInformation.loanOfficerName || '';
      this.formData.loEmail = this.brokerInformation.loanOfficerEmail || '';
      this.formData.tpoCompanyName = this.brokerInformation.tpoCompanyName || '';
      this.formData.tpoCompanyPhone = this.brokerInformation.tpoCompanyPhone || '';
      this.formData.tpoCompanyFax = this.brokerInformation.tpoCompanyFax || '';
    }

    this.formData.willSnapDocsBeUsed = this.willSnapDocsBeUsed ?? null;
    this.formData.isHybridClosing = this.isHybridClosing ?? null;
  }
}
